// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-list[data-v-02dcbb8e]{overflow:hidden;margin:-5px 5px -5px -5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
